// extracted by mini-css-extract-plugin
export default {"Menu":"bgn_a bhb_h","Menu__offsetParent":"bgn_b bhb_bj","Menu__trigger--shadowed":"bgn_c"};